import { useNavigate, useLocation } from 'react-router-dom';
import { Object2Query } from '@utils/tools';
import { appendQuery2TargetUrlFromCurrentUrl, isInWhiteListOfHostFn } from '@utils/url';
import formatUrl from '@utils/formatUrl';
import { urlParse } from '@block/utils';

interface Opts {
  state?: object;
  replace?: boolean;
  isNeedFormatUrl?: boolean;
  isAppendQuery?: boolean; // 是否默认将，当前url上token staffSsoId等追加到目标url
  isfullUrl?: boolean;
}

function goFn(navigate, pathname: string, queryInfo?: object, opts?: Opts, location?: any) {
  if (!pathname || typeof pathname !== 'string') {
    console.error('pathname 为无效值');
    return;
  }
  const { isNeedFormatUrl, isAppendQuery = true } = opts || {};
  if (isAppendQuery) {
    // 处理分享参数不丢失
    const currentQueryInfo = urlParse(location?.search);
    const { token, staffSsoId } = currentQueryInfo;
    if (staffSsoId) {
      queryInfo = {
        ...queryInfo,
        staffSsoId,
      };
    }
    if (token) {
      queryInfo = {
        ...queryInfo,
        token,
      };
    }
  }
  let newUrl = pathname;
  if (queryInfo && isNeedFormatUrl) {
    queryInfo = formatUrl(queryInfo);
  }
  const queryStr = queryInfo ? Object2Query(queryInfo) : '';
  if (queryStr) {
    const hasQuestionMark = /\?.+/.test(pathname);
    if (hasQuestionMark) {
      newUrl = `${pathname}&${queryStr}`;
    } else {
      newUrl = `${pathname}?${queryStr}`;
    }
  }
  const { replace = false, state, isfullUrl } = opts || {};
  if (isfullUrl) {
    window.location.href = newUrl;
  } else {
    navigate(newUrl, { replace, state });
  }
}

interface IJumpOpts {
  isAppendQuery?: boolean; // 是否默认将，当前url上token staffSsoId等追加到目标url
}

// 增加了host白名单验证和自动将当前url上token staffSsoId等追加到目标url
function dealUrl(url, opts?: IJumpOpts): string {
  const { isAppendQuery = true } = opts || {};
  const newUrl = new URL(url, window.location.origin);
  let target = newUrl.href;
  if (!isInWhiteListOfHostFn(target)) {
    return '';
  }
  if (isAppendQuery) {
    target = appendQuery2TargetUrlFromCurrentUrl(url);
  }
  return target;
}

// window.location.href 打开链接
function jump(url, opts?: IJumpOpts) {
  const target = dealUrl(url, opts);
  if (!target) {
    return;
  }
  window.location.href = target;
}

function jumpReplace(url, opts?: IJumpOpts) {
  const target = dealUrl(url, opts);
  if (!target) {
    return;
  }
  window.location.replace(target);
}

// window.open 打开链接
function jumpOpen(url, opts?: IJumpOpts) {
  const target = dealUrl(url, opts);
  if (!target) {
    return;
  }
  window.open(target);
}

export { jump, jumpReplace, jumpOpen };

export default function useGo() {
  const navigate = useNavigate();
  const location = useLocation();

  function go(pathname: string, queryInfo?: object, opts?: Opts) {
    const newOpts = { ...opts, replace: false };
    goFn(navigate, pathname, queryInfo, newOpts, location);
  }

  function replace(pathname: string, queryInfo?: object, opts?: Opts) {
    const newOpts = { ...opts, replace: true };
    goFn(navigate, pathname, queryInfo, newOpts, location);
  }

  function goForward() {
    navigate(1);
  }

  function goBack() {
    navigate(-1);
  }

  return {
    go,
    replace,
    goForward,
    goBack,
  };
}
